module.exports = __webpack_public_path__ + "img/marker.5a7ac053.svg";